import { each } from '../util'

/**
 * @module EventSelector
 */
const EventSelector = (() => {

  let selectedEvent = null

  const manageButtons = (selector) => {
    const buttons = document.querySelectorAll('.js-event-selector-activator')
    const inputTypology = selector.querySelector('.js-event-selector-typology')
    if (!inputTypology) return

    each(buttons, (_i, button) => {
      button.addEventListener('click', () => {
        inputTypology.value = button.getAttribute('data-typology')
      })
    })
  }

  const manageSubmit = (selector) => {
    const submit = selector.querySelector('.js-event-selector-submit')
    if (!submit) return

    // NOTE: Temporanemante disattivato per permettere aggiunta comunque
    // submit.setAttribute('disabled', 'true')

    // submit.addEventListener('click', (e) => {
    //   if (!selectedEvent) {
    //     e.preventDefault()
    //   }
    // })
  }

  const initSelector = (selector) => {
    const buttons = selector.querySelectorAll('.js-event-selector-event-button')
    const inputEvent = selector.querySelector('.js-event-selector-event')
    const submit = selector.querySelector('.js-event-selector-submit')
    if (!inputEvent || !submit) return

    each(buttons, (_i, button) => {
      button.addEventListener('click', (e) => {
        e.preventDefault()
        const uuid = button.getAttribute('data-value')
        selectedEvent = uuid
        inputEvent.value = uuid
        submit.removeAttribute('disabled')
        const modal_content = document.querySelector(".modal__container");
         modal_content.scrollBy({ 
          top: 9999, // could be negative value
          behavior: 'smooth' 
        });
        each(buttons, (_i2, b) => {
          if (b == button) {
            b.classList.remove('c-button--main')
            b.classList.add('c-button--success')
            b.innerText = selector.getAttribute('data-selected')
          } else {
            b.classList.add('c-button--main')
            b.classList.remove('c-button--success')
            b.innerText = selector.getAttribute('data-select')
          }
        })
      })
    })
  }

  const init = () => {
    const eventSelector = document.querySelector('.js-event-selector')
    if (!eventSelector) return

    initSelector(eventSelector)
    manageButtons(eventSelector)
    manageSubmit(eventSelector)
  }

  return {
    init
  }
})()

export default EventSelector


// WEBPACK FOOTER //
// app/javascript/scripts/components/EventSelector.js